if (!customElements.get('hoculus-tax-id-code')) {
    class HoculusTaxIdCode extends HTMLElement {
        constructor() {
            super();
            this.taxOptions = this.querySelectorAll('input[type="radio"]');
            this.taxIdCodeWrap = this.querySelector('.hoculus-tax-id-code-field-wrap');
            this.taxIdCode = this.querySelector('input[id="tax-id-code"]');
            this.hiddenTaxIdCode = this.querySelector('input[name="attributes[Tax ID Code]"]');
            this.hiddenOptionValidator = this.querySelector('input[type="checkbox"]');
            this.form = this.closest('form[method="post"]');

            this.errorCodeMissingMessage = this.dataset.errorsCodeMissing;
            this.errorCodeInvalidMessage = this.dataset.errorsCodeInvalid;
            this.errorNoOptionSelectedMessage = this.dataset.errorsNoOptionSelected;
        }

        connectedCallback() {
            this.showTaxIdCode();
            this.validateTaxIdCode();
            this.bindOptionChangeValidation();
            this.handleSubmit();
        }

        bindOptionChangeValidation() {
            this.taxOptions.forEach(option => {
                option.addEventListener('change', () => {
                    this.hiddenOptionValidator.setCustomValidity('');
                    this.hiddenOptionValidator.checked = true;
                });
            });
        }

        showTaxIdCode() {
            Array.from(this.taxOptions).find(option => option.id === 'primary-tax-id-code-option')?.checked && (this.taxIdCodeWrap.classList.add('show'), (this.taxIdCode.required = true));
            this.isOptionSelected() && ((this.hiddenOptionValidator.checked = true), this.hiddenOptionValidator.setCustomValidity(''));
            
            this.taxOptions.forEach((option) => {
                option.addEventListener('change', (e) => {
                    if (e.target.id === 'primary-tax-id-code-option') {
                        this.taxIdCodeWrap.classList.add('show');
                        this.taxIdCode.required = true;
                    } else {
                        this.taxIdCodeWrap.classList.remove('show');
                        this.taxIdCode.required = false;
                        this.taxIdCode.setCustomValidity(''); 
                    }
                });
            });
        }

        validateTaxIdCode(){
            this.taxIdCode.addEventListener('input', () => {
                let taxIdValue = this.taxIdCode.value.toUpperCase();
                this.taxIdCode.value = taxIdValue;

                if(this.isValueEmpty(taxIdValue)) {
                    this.taxIdCode.setCustomValidity(this.errorCodeMissingMessage);
                } else if (!this.isValueConform(taxIdValue)) {
                    this.taxIdCode.setCustomValidity(this.errorCodeInvalidMessage);
                } else {
                    this.taxIdCode.setCustomValidity('');
                }
                this.hiddenTaxIdCode.value = taxIdValue;
            });
        }

        handleSubmit() {
            this.form.addEventListener('submit', (e) => {
                if(!this.isOptionSelected()) {
                    e.preventDefault();
                    this.hiddenOptionValidator.setCustomValidity(this.errorNoOptionSelectedMessage);
                }
            });
        }

        isValueConform(value) {
            return /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/.test(value);
        }

        isValueEmpty(value) {
            return value.trim() === '';
        }
        
        isOptionSelected() {
            return Array.from(this.taxOptions).some(option => option.checked);
        }
    }

    customElements.define('hoculus-tax-id-code', HoculusTaxIdCode);
}